import { imdbSeasonDetailsDto } from "../../api";
import Episode from "./episode.component";

export interface SeasonProps {
    seasonNumber: number;
    seasonDetails: imdbSeasonDetailsDto;
    episodesPerSeason: number;
    highestRating: number;
    lowestRating: number;
}

const Season = ({seasonNumber, seasonDetails, episodesPerSeason, highestRating, lowestRating}: SeasonProps) => {
    const seasonRating = seasonDetails.averageRating < 10 ? seasonDetails.averageRating.toFixed(1) : 10;
    const showSeasonRating = seasonDetails.averageRating !== -1;

    return (
        <div className="season-column">
            <div className="column-header">{seasonNumber}</div>
            {seasonDetails?.episodes && Object.entries(seasonDetails?.episodes).map(([episodeNumber, episodeDetails]) => 
                <Episode episodeDetails={episodeDetails} highestRating={highestRating} lowestRating={lowestRating} />
            )}

            {[...Array(episodesPerSeason - Object.keys(seasonDetails?.episodes).length)].map((x,i) =>
                <div className="blank"></div>
            )}

            <div className={`${showSeasonRating ? "average" : "average-no-rating"}`} style={{backgroundPositionY: `${seasonDetails.averageRating * 200}px`}} title={`Season ${seasonNumber} average`}>{showSeasonRating && seasonRating}</div>
        </div>
    );
}

export default Season